module.exports = __webpack_public_path__ + "static/media/B_mint_breeze.96ed908c.png";